import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class Admin_Dashboard_Daily_Late_Early implements IAdmin_Dashboard_Daily_Late_Early {
    employee!: EmployeeSummaryDto;
    entryDate!: Date | undefined;
    lateTime!: string | undefined;
    earlyTime!: string | undefined;

    constructor(data?: IAdmin_Dashboard_Daily_Late_Early) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.lateTime = _data["lateTime"];
            this.earlyTime = _data["earlyTime"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Daily_Late_Early {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Daily_Late_Early();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["lateTime"] = this.lateTime;
        data["earlyTime"] = this.earlyTime;
        return data; 
    }
}

export interface IAdmin_Dashboard_Daily_Late_Early {
    employee: EmployeeSummaryDto;
    entryDate: Date | undefined;
    lateTime: string | undefined;
    earlyTime: string | undefined;
}

